<div class="bulk-btn">
  <button  [disabled]="isCampaignLoading" (click)="!isCampaignLoading && handleContinueCta($event)" mat-button>Continue</button>
</div>

<ng-template #bulkDonation>
  <div class="wrap-bulk">
    <div class="header">
      <div class="maintitle">Contribute as much as you can</div>
      <div class="subtitle">Fundraisers that couldn’t raise money</div>
    </div>
    <div class="divideline"></div>
    <div class="storytiles" *ngFor="let item of campaigns">
      <div class="tile">
        <div class="tileinfo">
          <div class="timeleft">
            <em class="material-icons">schedule</em>
            <span>{{item?.end_date | customDate:'remaingTime':'D-H'}} left</span>
          </div>
          <div class="storytitle">{{item?.title}}</div>
          <div class="moneyshort"  *ngIf="item?.amount_remaining"><strong><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{item?.amount_remaining | inrFormat}}</strong> remaining</div>
          <div class="progress">
            <app-progress-bar [amount]="item?.raised?.raised" [goal]="item?.amount_requested"></app-progress-bar>
          </div>
        </div>
        <div class="tileimg">
          <img loading="lazy" [attr.data-src]="item?.story_widget?.cdn_path || item?.widget?.cdn_path" appImgFallback [default]="vars.defaultImg" alt="">
          <div class="dntbtn">
            <button *ngIf="!selected.includes(item.id)" class="btn" (click)="hide(item.id)">
              <em class="material-icons">add</em>
              Contribute
            </button>
          </div>
          <div class="incrementbtn" *ngIf="selected.includes(item.id)">
            <button class="plus" (click)="amtchanger('minus', item.id)" mat-ripple>
              <em class="material-icons">remove</em>
            </button>
            <div><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>{{bulkData[item.id].amount}}</div>
            <button class="minus" (click)="amtchanger('plus', item.id)" [class.max]="bulkData[item.id].amount === minamount[currency].minamt * 20" mat-ripple>
              <em class="material-icons">add</em>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="submitbtn" [class.active]="isAnySelected">
      <button (click)="submit()" mat-button [disabled]="isOrderLoading ? true : false">
        <span *ngIf="!isOrderLoading">{{btnlabel}}</span>
        <div *ngIf="isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </div>
  </div>
</ng-template>
